import React from 'react';
import {Card, CardText} from 'material-ui/Card';

const styles = {
  card:{
    margin:5,
  },
  cardheader:{
    paddingBottom:0,
  },
  maintext:{
    paddingTop:10,
    paddingBottom:5,
  }
};

export default class SummaryCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardText
          style={styles.maintext}
        >
          <div>
              Engineer with 17 years of broad experience including mathematical analysis, project management,
              product development, product sales, and self-learned website/app programming.
            <br /><br />
              Programming experience includes single-handed development of complete websites (including full-stack) and mobile device
              applications.
            <br /><br />
              Seeking employment in Mechanical Engineering and/or Programming.
          </div>

        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SummaryCard.js